
<gost-digest-card #gost_digest_card [recordData]="this.recordData"  [recordDataUpdated]="this.recordDataUpdated"  style="display: none;"></gost-digest-card>

<ng-template #scCell let-row="row" let-rowIndex="rowIndex" let-colIndex="colIndex" let-columnDef="columnDef" let-tableDef="tableDef">
  @if (tableDef.isMeasured(columnDef)) {
    @if (rowIndex < tableDef.tableRows.length - 1) {
      <span>
        @if (isInputMode()) {
          @if (tableDef.tableRows[rowIndex].code === "otherAbnormality") {
            <!-- 注意項目: カード型と同じ abnormal-pill を使用 -->
            <div class="gost-sc-table-abnormal-group">
              @for (abnormalCode of scAbnormalCodes; track abnormalCode) {
                <button
                  type="button"
                  class="gost-sc-abnormal-pill"
                  [class.gost-sc-abnormal-pill--active]="isScCellPositive(tableDef, abnormalCode, columnDef)"
                  [attr.aria-pressed]="isScCellPositive(tableDef, abnormalCode, columnDef)"
                  [attr.aria-label]="getScRowFormalLabel(tableDef, abnormalCode) + (isScCellPositive(tableDef, abnormalCode, columnDef) ? ' 選択中' : '')"
                  matTooltip="{{ getScRowFormalLabel(tableDef, abnormalCode) }}"
                  (click)="tableDef.toggleScCell(columnDef, abnormalCode)">
                  <mat-icon class="gost-sc-abnormal-pill__icon">
                    {{ isScCellPositive(tableDef, abnormalCode, columnDef) ? 'check_circle' : 'radio_button_unchecked' }}
                  </mat-icon>
                  {{ getScRowFormalLabel(tableDef, abnormalCode) }}
                </button>
              }
            </div>
          } @else {
            <!-- 嚥下/むせ: カード型と同じ有/無トグルを使用 -->
            <mat-button-toggle-group
              class="gost-sc-toggle"
              [class.gost-sc-toggle--good]="rowIndex === 0 && row.cellValues[colIndex]"
              [class.gost-sc-toggle--bad]="rowIndex !== 0 && row.cellValues[colIndex]"
              [value]="row.cellValues[colIndex] ? 'yes' : (isScFieldExplicitlySet(tableDef, tableDef.tableRows[rowIndex].code, columnDef) ? 'no' : '')"
              (change)="onScInlineToggle(tableDef, columnDef, tableDef.tableRows[rowIndex].code, $event.value === 'yes')"
              [attr.aria-label]="row.label">
              <mat-button-toggle value="yes" i18n="@@home.gostInfos.toggle.yes">有</mat-button-toggle>
              <mat-button-toggle value="no" i18n="@@home.gostInfos.toggle.no">無</mat-button-toggle>
            </mat-button-toggle-group>
          }
        }
        @if (!isInputMode() && row.cellValues[colIndex]) {
          @if (tableDef.isMeasured(columnDef)) {
            <!-- 閲覧モード: カード型と同じバッジ -->
            <span class="gost-sc-inline__badge"
              [class.gost-sc-inline__badge--good]="rowIndex === 0"
              [class.gost-sc-inline__badge--bad]="rowIndex !== 0">
              @if (rowIndex === 0) {
                <ng-container i18n="@@home.gostInfos.badge.swallowPresent">嚥下あり</ng-container>
              } @else {
                <ng-container i18n="@@home.gostInfos.badge.coughPresent">せき・むせ</ng-container>
              }
            </span>
          }
        }
      </span>
    }
    <!-- 判定行: カード型と同じ result-chip -->
    @if (rowIndex === tableDef.tableRows.length - 1) {
      <span>
        @if (tableDef.isMeasured(columnDef)) {
          <span class="gost-sc-inline__result-chip" [class]="getScTrialResultClass(columnDef)">
            {{ getScTrialResultLabel(columnDef) }}
          </span>
        }
      </span>
    }
  } @else {
    <span class="not-measured-placeholder">-</span>
  }
</ng-template>

<ng-template #scTable let-tableDef="tableDef">
  <div class="table-container table-container--scroll">
    <table mat-table [dataSource]="tableDef.dataSource" class="custom-table">
      <ng-container [matColumnDef]="tableDef.allColumnDefs[0]">
        <th mat-header-cell *matHeaderCellDef  class="item-header" i18n="@@home.gostInfos.label.item" matTooltip="項目" matTooltipClass="tooltip-wrap"> 項目 </th>
        <td mat-cell *matCellDef="let row; let rowIndex = index" class="item-cell"
          [ngClass]="{ 'dark-background small-width': rowIndex >= 3 && rowIndex < tableDef.tableRows.length - 1 }"
          >
          <span matTooltip="{{ row.label }}" matTooltipClass="tooltip-wrap">{{ row.shortLabel || row.label }}</span>
          @if (rowIndex == 2 && !isInputMode()) {
            <button
              mat-icon-button
              type="button"
              class="gost-sc-detail-toggle"
              [attr.aria-label]="tableDef.detailHidden ? '注意項目を展開' : '注意項目を折りたたむ'"
              [matTooltip]="tableDef.detailHidden ? '注意項目を展開' : '注意項目を折りたたむ'"
              (click)="tableDef.toggleDetails()">
              @if (tableDef.detailHidden) {
                <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
              }
              @if (!tableDef.detailHidden) {
                <mat-icon fontSet="material-icons-outlined">expand_less</mat-icon>
              }
            </button>
          }
        </td>
      </ng-container>

      @for (columnDef of tableDef.dataColumnDefs; track columnDef; let colIndex = $index) {
        <ng-container [matColumnDef]="columnDef" >
          <th mat-header-cell *matHeaderCellDef class="gost-sc-header-cell"
            [class.gost-sc-header-cell--measured]="tableDef.isMeasured(columnDef)">
            {{ columnDef }}
            @if (isInputMode()) {
              <label class="gost-measured-toggle" i18n="@@home.gostInfos.label.measured">
                <input
                  type="checkbox"
                  class="gost-measured-toggle__input"
                  [(ngModel)]="tableDef.getScRoundByColumnDef(columnDef).isMeasured"
                  (change)="tableDef.toggleMeasured($event, columnDef)">
                <span class="gost-measured-toggle__label">測定済み</span>
              </label>
            }
          </th>
          <td mat-cell *matCellDef="let row; let rowIndex = index"  class="text-center"
          [ngClass]="{  'not-measured' : !tableDef.isMeasured(columnDef),
                        'dark-background': rowIndex >= 3 && rowIndex < tableDef.tableRows.length - 1  && tableDef.isMeasured(columnDef),
                        'disabled' :  !isInputMode()  && tableDef.isMeasured(columnDef) }"
            >
            <ng-container *ngTemplateOutlet="scCell; context: { row: row, rowIndex: rowIndex, colIndex: colIndex, columnDef: columnDef, tableDef: tableDef }"></ng-container>
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="tableDef.allColumnDefs"></tr>
      <tr mat-row *matRowDef="let row; columns: tableDef.allColumnDefs; let rowIndex=index"
      [ngClass]="{ 'hidden-row' : rowIndex >= 3 && rowIndex < tableDef.tableRows.length - 1 && (tableDef.detailHidden || isInputMode()) }"></tr>
    </table>
  </div>
</ng-template>


<ng-template #gcOcTable let-title="title" let-desc="desc" let-icon="icon" let-iconFontSet="iconFontSet" let-tableDef="tableDef">
  <mat-card class="gost-card" [class.gost-card--input]="isInputMode()" appearance="outlined">
    <mat-card-header class="gost-card-header--inline" [class.gost-card-header--with-help]="isInputMode()">
      <mat-card-title>
        <h3 class="gost-section-title">
          <mat-icon [fontSet]="iconFontSet || 'material-icons-outlined'" class="gost-section-title__icon">{{ icon }}</mat-icon>
          <span>{{ title }}</span>
        </h3>
      </mat-card-title>
      <mat-card-subtitle>{{ desc }}</mat-card-subtitle>
      @if (isInputMode()) {
        <button
          mat-icon-button
          type="button"
          class="gost-card-help-button"
          aria-label="入力ヘルプ"
          i18n-aria-label="@@home.gostInfos.ariaLabel.inputHelp"
          matTooltip="4つの状態から最も近いものを1つ選択してください。"
          i18n-matTooltip="@@home.gostInfos.tooltip.selectClosestState"
          matTooltipClass="tooltip-wrap">
          <mat-icon fontSet="material-icons-outlined">help_outline</mat-icon>
        </button>
      }
    </mat-card-header>

    <mat-card-content>
      <mat-accordion>
        <mat-expansion-panel class="gost-panel" [expanded]="isInputMode() || isHandset">
          <mat-expansion-panel-header>
            <mat-panel-title class="gost-panel-title" i18n="@@home.gostInfos.label.totalScore">
              総スコア: {{ tableDef.originalData.totalScore }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="gost-input-questionnaire" [class.gost-input-questionnaire--readonly]="!isInputMode()">
            <div class="gost-input-questionnaire__summary">
              <span>
                @if (isInputMode()) {
                  <ng-container i18n="@@home.gostInfos.label.enteredCount">入力済み {{ tableDef.getFilledRowCount() }} / {{ tableDef.tableRows.length }}</ng-container>
                } @else {
                  <ng-container i18n="@@home.gostInfos.label.recordedCount">記録済み {{ tableDef.getFilledRowCount() }} / {{ tableDef.tableRows.length }}</ng-container>
                }
              </span>
            </div>

            @for (row of tableDef.tableRows; track row.code; let rowIndex = $index) {
              <article class="gost-question-card" [class.gost-question-card--readonly]="!isInputMode()">
                <div class="gost-question-card__top">
                  <p class="gost-question-card__title">{{ row.label }}</p>
                  @if (isInputMode()) {
                    <p class="gost-question-card__selected"><ng-container i18n="@@home.gostInfos.label.selected">選択中: {{ tableDef.getSelectedOptionLabel(row.code) }}</ng-container></p>
                  }
                </div>

                <div class="gost-question-options" role="radiogroup" [attr.aria-label]="row.label">
                  @for (cellValue of row.cellValues; track $index; let colIndex = $index) {
                    <button
                      mat-stroked-button
                      type="button"
                      class="gost-question-option"
                      [class.gost-question-option--readonly]="!isInputMode()"
                      [class.gost-question-option--selected]="tableDef.getScore(row.code) === colIndex - 3"
                      [class.gost-question-option--bad]="colIndex === 0"
                      [class.gost-question-option--acceptable]="colIndex === 1 || colIndex === 2"
                      [class.gost-question-option--good]="colIndex === 3"
                      [attr.aria-pressed]="tableDef.getScore(row.code) === colIndex - 3"
                      [attr.aria-disabled]="!isInputMode()"
                      (click)="onGcOcOptionClick(tableDef, rowIndex, colIndex)">
                      <span class="gost-question-option__text">{{ cellValue }}</span>
                    </button>
                  }
                </div>
              </article>
            }
          </div>


        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #scSection>
  <mat-card class="gost-card" [class.gost-card--input]="isInputMode()" appearance="outlined">
    <mat-card-header class="gost-card-header--inline" [class.gost-card-header--with-help]="isInputMode()">
      <mat-card-title>
        <h3 class="gost-section-title">
          <mat-icon fontSet="material-icons-outlined" class="gost-section-title__icon">local_drink</mat-icon>
          <span i18n="@@home.gostInfos.title.waterTest">水飲みテスト（SC）</span>
        </h3>
      </mat-card-title>
      <mat-card-subtitle i18n="@@home.gostInfos.label.waterTestResult">段階的水飲みテストの結果</mat-card-subtitle>
      @if (isInputMode()) {
        <button
          mat-icon-button
          type="button"
          class="gost-card-help-button"
          aria-label="入力ヘルプ"
          i18n-aria-label="@@home.gostInfos.ariaLabel.scInputHelp"
          matTooltip="各反応を入力すると自動で測定済みになります。未計測に戻す場合は「入力内容をクリア」を使用してください。"
          i18n-matTooltip="@@home.gostInfos.tooltip.scInputHelp"
          matTooltipClass="tooltip-wrap">
          <mat-icon fontSet="material-icons-outlined">help_outline</mat-icon>
        </button>
      }
    </mat-card-header>

    <mat-card-content>
      <mat-accordion>
        <mat-expansion-panel class="gost-panel" [expanded]="isInputMode() || isHandset">
          <mat-expansion-panel-header>
            <mat-panel-title class="gost-panel-title">
              @if (scInputMode === 'without') {
                <ng-container i18n="@@home.gostInfos.sc.panelTitleWithout">通常水 スコア: {{ getActiveScTableDef().originalData.totalScore }} レベル: {{ this.recordData.data.gostSCData.level }} ({{ getScTrialCount() }}試行)</ng-container>
              } @else {
                <ng-container i18n="@@home.gostInfos.sc.panelTitleWith">トロミ スコア: {{ getActiveScTableDef().originalData.totalScore }} レベル: {{ this.recordData.data.gostSCData.withThicknessLevel }} ({{ getScTrialCount() }}試行)</ng-container>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>

            <div class="gost-sc-design" [class.gost-sc-design--readonly]="!isInputMode()">
              <!-- ── Mode row: tabs + view toggle ── -->
              <div class="gost-sc-design__mode-row">
                <div class="gost-sc-design__tabs">
                  <mat-button-toggle-group
                    class="gost-sc-mode-toggle"
                    [value]="scInputMode"
                    (change)="setScInputMode($event.value)"
                    aria-label="水の種類">
                    <mat-button-toggle value="without" i18n="@@home.gostInfos.sc.normalWater">通常水</mat-button-toggle>
                    <mat-button-toggle value="with" i18n="@@home.gostInfos.sc.thickened">トロミ</mat-button-toggle>
                  </mat-button-toggle-group>
                  <span class="gost-sc-design__progress-pill">
                    <ng-container i18n="@@home.gostInfos.sc.enteredProgress">入力済み {{ getScTrialStats(getActiveScTableDef()).measured }}/{{ getScTrialStats(getActiveScTableDef()).total }}</ng-container>
                  </span>
                </div>

                <div class="gost-sc-design__meta">
                  @if (!isHandset && isInputMode()) {
                    <div class="view-toggle" role="group" aria-label="表示切替" i18n-aria-label="@@home.gostInfos.ariaLabel.viewToggle">
                      <button
                        mat-icon-button
                        type="button"
                        [class.view-toggle--active]="scInputDisplayMode === 'card'"
                        [attr.aria-pressed]="scInputDisplayMode === 'card'"
                        matTooltip="カード入力"
                        i18n-matTooltip="@@home.gostInfos.ariaLabel.cardInput"
                        aria-label="カード入力"
                        i18n-aria-label="@@home.gostInfos.ariaLabel.cardInput"
                        (click)="setScInputDisplayMode('card')">
                        <mat-icon>view_module</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        type="button"
                        [class.view-toggle--active]="scInputDisplayMode === 'table'"
                        [attr.aria-pressed]="scInputDisplayMode === 'table'"
                        matTooltip="表入力"
                        i18n-matTooltip="@@home.gostInfos.ariaLabel.tableInput"
                        aria-label="表入力"
                        i18n-aria-label="@@home.gostInfos.ariaLabel.tableInput"
                        (click)="setScInputDisplayMode('table')">
                        <mat-icon>view_list</mat-icon>
                      </button>
                    </div>
                  }
                </div>
              </div>

              <!-- ════════════════════════════════════════════ -->
              <!-- MOBILE: card-based trial editor             -->
              <!-- ════════════════════════════════════════════ -->
              @if (isHandset) {
                <div class="gost-sc-mobile">
                  <!-- ── セクション1: 試行選択 ── -->
                  <div class="gost-sc-mobile__trial-section">
                    <div class="gost-sc-mobile__nav">
                      <button
                        mat-icon-button
                        type="button"
                        class="gost-sc-mobile__nav-btn"
                        [disabled]="!canNavigateScPrev()"
                        (click)="navigateScTrial(-1)"
                        aria-label="前の試行"
                        i18n-aria-label="@@home.gostInfos.ariaLabel.prevTrial">
                        <mat-icon>chevron_left</mat-icon>
                      </button>
                      <span class="gost-sc-mobile__nav-current">{{ getScActiveColumnDef() }}</span>
                      <button
                        mat-icon-button
                        type="button"
                        class="gost-sc-mobile__nav-btn"
                        [disabled]="!canNavigateScNext()"
                        (click)="navigateScTrial(1)"
                        aria-label="次の試行"
                        i18n-aria-label="@@home.gostInfos.ariaLabel.nextTrial">
                        <mat-icon>chevron_right</mat-icon>
                      </button>
                    </div>
                    <div class="gost-sc-mobile__chips">
                      @for (columnDef of getActiveScTableDef().dataColumnDefs; track columnDef; let index = $index) {
                        <button
                          type="button"
                          class="gost-sc-mobile__chip"
                          [class.gost-sc-mobile__chip--active]="getScActiveColumnDef() === columnDef"
                          [class.gost-sc-mobile__chip--measured]="getActiveScTableDef().isMeasured(columnDef)"
                          (click)="selectScTrialByIndex(index)">
                          {{ columnDef }}
                        </button>
                      }
                    </div>
                  </div>

                  <!-- ── セクション2: 入力エリア ── -->
                  <div class="gost-sc-mobile__input-section">
                    <div class="gost-sc-mobile__primary-row">
                      @for (code of scPrimaryCodes; track code) {
                        <div class="gost-sc-mobile__primary-item">
                          <span class="gost-sc-mobile__primary-label">{{ getScRowLabel(getActiveScTableDef(), code) }}</span>
                          <mat-button-toggle-group
                            class="gost-sc-toggle"
                            [class.gost-sc-toggle--good]="code === 'swallowResult' && isScCellPositive(getActiveScTableDef(), code, getScActiveColumnDef())"
                            [class.gost-sc-toggle--bad]="code === 'coughResult' && isScCellPositive(getActiveScTableDef(), code, getScActiveColumnDef())"
                            [value]="isScCellPositive(getActiveScTableDef(), code, getScActiveColumnDef()) ? 'yes' : (isScFieldExplicitlySet(getActiveScTableDef(), code, getScActiveColumnDef()) ? 'no' : '')"
                            [disabled]="!isInputMode()"
                            (change)="onScPrimaryChoice(getActiveScTableDef(), code, $event.value === 'yes')"
                            [attr.aria-label]="getScRowLabel(getActiveScTableDef(), code)">
                            <mat-button-toggle value="yes" i18n="@@home.gostInfos.toggle.yes">有</mat-button-toggle>
                            <mat-button-toggle value="no" i18n="@@home.gostInfos.toggle.no">無</mat-button-toggle>
                          </mat-button-toggle-group>
                        </div>
                      }
                    </div>

                    <button
                      type="button"
                      class="gost-sc-mobile__abnormal-toggle"
                      (click)="toggleScMobileAbnormal()"
                      [attr.aria-expanded]="scMobileAbnormalExpanded">
                      <mat-icon fontSet="material-icons-outlined" class="gost-sc-mobile__abnormal-toggle-icon">
                        {{ scMobileAbnormalExpanded ? 'expand_less' : 'expand_more' }}
                      </mat-icon>
                      <span i18n="@@home.gostInfos.label.cautionItems">注意項目</span>
                      <span class="gost-sc-mobile__abnormal-count"
                        [class.gost-sc-mobile__abnormal-count--active]="getScAbnormalCount(getActiveScTableDef(), getScActiveColumnDef()) > 0">
                        <ng-container i18n="@@home.gostInfos.label.cautionCount">{{ getScAbnormalCount(getActiveScTableDef(), getScActiveColumnDef()) }}件</ng-container>
                      </span>
                    </button>
                    @if (scMobileAbnormalExpanded) {
                      <div class="gost-sc-mobile__abnormal">
                        @for (code of scAbnormalCodes; track code) {
                          <button
                            type="button"
                            class="gost-sc-abnormal-pill"
                            [class.gost-sc-abnormal-pill--active]="isScCellPositive(getActiveScTableDef(), code, getScActiveColumnDef())"
                            [class.gost-sc-abnormal-pill--readonly]="!isInputMode()"
                            [attr.aria-pressed]="isScCellPositive(getActiveScTableDef(), code, getScActiveColumnDef())"
                            [attr.aria-disabled]="!isInputMode()"
                            (click)="onScAbnormalToggle(getActiveScTableDef(), code)">
                            <mat-icon class="gost-sc-abnormal-pill__icon">
                              {{ isScCellPositive(getActiveScTableDef(), code, getScActiveColumnDef()) ? 'check_circle' : 'radio_button_unchecked' }}
                            </mat-icon>
                            {{ getScRowFormalLabel(getActiveScTableDef(), code) }}
                          </button>
                        }
                      </div>
                    }
                  </div>

                  <!-- ── セクション3: 判定 + アクション ── -->
                  <div class="gost-sc-mobile__actions">
                    <span class="gost-sc-mobile__result"><ng-container i18n="@@home.gostInfos.label.verdict">判定:</ng-container>
                      <span class="gost-sc-inline__result-chip"
                        [class.is-good]="getScActiveTestResultClass() === 'is-good'"
                        [class.is-warn]="getScActiveTestResultClass() === 'is-warn'"
                        [class.is-bad]="getScActiveTestResultClass() === 'is-bad'"
                        [class.is-neutral]="getScActiveTestResultClass() === 'is-neutral'"
                        [class.gost-sc-result-chip--empty]="!isScMeasuredOnActiveTrial()">{{ getScActiveTestResultLabel() }}</span>
                    </span>
                    @if (isInputMode()) {
                      <div class="gost-sc-mobile__action-buttons">
                        <button mat-button type="button" color="warn" class="gost-sc-clear-btn" (click)="onScClearActiveTrial()">
                          <ng-container i18n="@@home.gostInfos.button.clear">クリア</ng-container>
                        </button>
                        <button mat-stroked-button type="button" class="gost-sc-next-btn" (click)="onScGoToNextTrial()">
                          <ng-container i18n="@@home.gostInfos.button.next">次へ</ng-container>
                        </button>
                      </div>
                    }
                  </div>
                </div>

              <!-- ════════════════════════════════════════════ -->
              <!-- DESKTOP: inline table input (card mode)     -->
              <!-- ════════════════════════════════════════════ -->
              } @else if (!isInputMode() || scInputDisplayMode === 'card') {
                <div class="gost-sc-inline">
                  <!-- ── Header row ── -->
                  <div class="gost-sc-inline__header">
                    <span class="gost-sc-inline__col gost-sc-inline__col--trial"><span i18n="@@home.gostInfos.sc.colWaterAmount">水量</span></span>
                    <span class="gost-sc-inline__col gost-sc-inline__col--swallow"><span i18n="@@home.gostInfos.sc.colSwallow">嚥下</span></span>
                    <span class="gost-sc-inline__col gost-sc-inline__col--cough"><span i18n="@@home.gostInfos.sc.colCough">むせ</span></span>
                    <span class="gost-sc-inline__col gost-sc-inline__col--abnormal"><span i18n="@@home.gostInfos.sc.colCautions">注意項目</span></span>
                    <span class="gost-sc-inline__col gost-sc-inline__col--result"><span i18n="@@home.gostInfos.sc.colVerdict">判定</span></span>
                  </div>

                  <!-- ── Trial rows ── -->
                  @for (columnDef of getActiveScTableDef().dataColumnDefs; track columnDef; let rowIdx = $index) {
                    <div class="gost-sc-inline__row"
                      [class.gost-sc-inline__row--unmeasured]="!getActiveScTableDef().isMeasured(columnDef)"
                      [class.gost-sc-inline__row--active]="getScActiveColumnDef() === columnDef && isInputMode()"
                      tabindex="0"
                      role="row"
                      (click)="onScInlineRowClick(rowIdx, columnDef)"
                      (keydown.enter)="onScInlineRowClick(rowIdx, columnDef)"
                      (keydown.space)="onScInlineRowClick(rowIdx, columnDef); $event.preventDefault()">

                      <!-- 水量 -->
                      <span class="gost-sc-inline__col gost-sc-inline__col--trial">
                        {{ columnDef }}
                      </span>

                      @if (getActiveScTableDef().isMeasured(columnDef) || isInputMode()) {
                        <!-- 嚥下 [有|無] -->
                        <span class="gost-sc-inline__col gost-sc-inline__col--swallow">
                          @if (isInputMode()) {
                            <mat-button-toggle-group
                              class="gost-sc-toggle"
                              [class.gost-sc-toggle--good]="isScSwallowPresent(getActiveScTableDef(), columnDef)"
                              [value]="isScSwallowPresent(getActiveScTableDef(), columnDef) ? 'yes' : (isScFieldExplicitlySet(getActiveScTableDef(), 'swallowResult', columnDef) ? 'no' : '')"
                              (change)="onScInlineToggle(getActiveScTableDef(), columnDef, 'swallowResult', $event.value === 'yes')"
                              aria-label="嚥下の有無">
                              <mat-button-toggle value="yes" i18n="@@home.gostInfos.toggle.yes">有</mat-button-toggle>
                              <mat-button-toggle value="no" i18n="@@home.gostInfos.toggle.no">無</mat-button-toggle>
                            </mat-button-toggle-group>
                          } @else {
                            @if (isScSwallowPresent(getActiveScTableDef(), columnDef)) {
                              <span class="gost-sc-inline__badge gost-sc-inline__badge--good" i18n="@@home.gostInfos.badge.swallowPresent">嚥下あり</span>
                            }
                          }
                        </span>

                        <!-- むせ [有|無] -->
                        <span class="gost-sc-inline__col gost-sc-inline__col--cough">
                          @if (isInputMode()) {
                            <mat-button-toggle-group
                              class="gost-sc-toggle"
                              [class.gost-sc-toggle--bad]="isScCoughPresent(getActiveScTableDef(), columnDef)"
                              [value]="isScCoughPresent(getActiveScTableDef(), columnDef) ? 'yes' : (isScFieldExplicitlySet(getActiveScTableDef(), 'coughResult', columnDef) ? 'no' : '')"
                              (change)="onScInlineToggle(getActiveScTableDef(), columnDef, 'coughResult', $event.value === 'yes')"
                              aria-label="せき・むせの有無">
                              <mat-button-toggle value="yes" i18n="@@home.gostInfos.toggle.yes">有</mat-button-toggle>
                              <mat-button-toggle value="no" i18n="@@home.gostInfos.toggle.no">無</mat-button-toggle>
                            </mat-button-toggle-group>
                          } @else {
                            @if (isScCoughPresent(getActiveScTableDef(), columnDef)) {
                              <span class="gost-sc-inline__badge gost-sc-inline__badge--bad" i18n="@@home.gostInfos.badge.coughPresent">せき・むせ</span>
                            }
                          }
                        </span>

                        <!-- 注意項目 -->
                        <span class="gost-sc-inline__col gost-sc-inline__col--abnormal">
                          @if (getScAbnormalCount(getActiveScTableDef(), columnDef) > 0) {
                            <button type="button"
                              class="gost-sc-inline__abnormal-badge gost-sc-inline__abnormal-badge--warn"
                              [attr.aria-expanded]="scExpandedAbnormalCol === columnDef"
                              (click)="toggleScInlineAbnormal(columnDef)">
                              <ng-container i18n="@@home.gostInfos.label.cautionCountWithPrefix">注意 {{ getScAbnormalCount(getActiveScTableDef(), columnDef) }}件</ng-container>
                            </button>
                          } @else if (isInputMode()) {
                            <button type="button"
                              class="gost-sc-inline__abnormal-badge"
                              [attr.aria-expanded]="scExpandedAbnormalCol === columnDef"
                              (click)="toggleScInlineAbnormal(columnDef)">
                              0件 ▸
                            </button>
                          } @else {
                            <span class="gost-sc-inline__abnormal-empty">—</span>
                          }
                        </span>

                        <!-- 判定 -->
                        <span class="gost-sc-inline__col gost-sc-inline__col--result">
                          <span class="gost-sc-inline__result-chip" [class]="getScTrialResultClass(columnDef)">
                            {{ getScTrialResultLabel(columnDef) }}
                          </span>
                        </span>
                      } @else {
                        <!-- 未測定行 -->
                        <span class="gost-sc-inline__col gost-sc-inline__col--unmeasured" style="grid-column: 2 / -1;">
                          <span class="gost-sc-inline__badge gost-sc-inline__badge--default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                        </span>
                      }
                    </div>

                    <!-- 異常展開パネル -->
                    @if (scExpandedAbnormalCol === columnDef) {
                      <div class="gost-sc-inline__abnormal-panel">
                        <div class="gost-sc-inline__abnormal-grid">
                          @for (code of scAbnormalCodes; track code) {
                            <button
                              type="button"
                              class="gost-sc-abnormal-pill"
                              [class.gost-sc-abnormal-pill--active]="isScCellPositive(getActiveScTableDef(), code, columnDef)"
                              [class.gost-sc-abnormal-pill--readonly]="!isInputMode()"
                              [attr.aria-pressed]="isScCellPositive(getActiveScTableDef(), code, columnDef)"
                              [attr.aria-disabled]="!isInputMode()"
                              (click)="onScInlineAbnormalToggle(getActiveScTableDef(), columnDef, code)">
                              <mat-icon class="gost-sc-abnormal-pill__icon">
                                {{ isScCellPositive(getActiveScTableDef(), code, columnDef) ? 'check_circle' : 'radio_button_unchecked' }}
                              </mat-icon>
                              {{ getScRowFormalLabel(getActiveScTableDef(), code) }}
                            </button>
                          }
                        </div>
                      </div>
                    }
                  }

                  <!-- ── Bottom actions ── -->
                  @if (isInputMode()) {
                    <div class="gost-sc-inline__actions">
                      <button mat-button type="button" color="warn" class="gost-sc-clear-btn" (click)="onScClearActiveTrial()">
                        <ng-container i18n="@@home.gostInfos.button.clearSelected">選択中をクリア</ng-container>
                      </button>
                    </div>
                  }
                </div>

              <!-- ════════════════════════════════════════════ -->
              <!-- DESKTOP: legacy table mode                  -->
              <!-- ════════════════════════════════════════════ -->
              } @else {
                <div class="gost-sc-table-mode">
                  <div class="gost-sc-table-mode__guide">
                    <p i18n="@@home.gostInfos.sc.tableGuideTitle">入力手順（表モード）</p>
                    <div>
                      <span i18n="@@home.gostInfos.sc.tableGuideStep1">1. 列ヘッダーで ☑測定済みにチェック</span>
                      <span i18n="@@home.gostInfos.sc.tableGuideStep2">2. 各セルを あり/なし で入力</span>
                      <span i18n="@@home.gostInfos.sc.tableGuideStep3">3. 最下段の判定を確認（自動算出）</span>
                    </div>
                  </div>

                  <div class="gost-sc-table-mode__viewport">
                    <ng-container *ngTemplateOutlet="scTable; context: { tableDef : getActiveScTableDef() }"></ng-container>
                  </div>
                </div>
              }

            </div>
          </mat-expansion-panel>

        </mat-accordion>
      </mat-card-content>
      @if (afterScTemplate) {
        <ng-container [ngTemplateOutlet]="afterScTemplate"></ng-container>
      }
    </mat-card>
</ng-template>

<ng-template #gcSection>
  <ng-container *ngTemplateOutlet="gcOcTable; context: { tableDef : gcTableDef, title : this.sections[0].title , desc: this.sections[0].desc, icon: this.sections[0].icon, iconFontSet: this.sections[0].iconFontSet }"></ng-container>
</ng-template>

<ng-template #ocSection>
  <ng-container *ngTemplateOutlet="gcOcTable; context: { tableDef : ocTableDef,  title : this.sections[1].title , desc: this.sections[1].desc, icon: this.sections[1].icon, iconFontSet: this.sections[1].iconFontSet }"></ng-container>
</ng-template>


@if (hasGostData) {
  @if (gost_digest_card.isInputMode() && !gost_digest_card.loading && recordData?.id == gostUtils.newGostId) {
    <div class="header-container gost-manual-header">
      <div class="gost-input-toolbar gost-input-toolbar--context gost-input-toolbar--plain">
        <div class="gost-input-toolbar__left">
          <mat-form-field appearance="outline" class="gost-input-toolbar__date-field">
            <mat-label i18n="@@home.gostDigest.label.evaluationDateInput">評価日</mat-label>
            <input
              matInput
              id="upload_date"
              (dateChange)="gost_digest_card.onUploadDateChange()"
              [matDatepicker]="manualDatepicker"
              [value]="gost_digest_card.dateAsDateObject"
              readonly>
            <mat-datepicker-toggle matSuffix [for]="manualDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #manualDatepicker></mat-datepicker>
          </mat-form-field>
          <button
            mat-stroked-button
            type="button"
            class="mat-elevation-z0 gost-action-button gost-action-button--copy"
            (click)="gost_digest_card.copyFromPreviousRecord()"
            [disabled]="!gost_digest_card.canCopyPreviousValues() || gost_digest_card.isCopyingPrevious()">
            <mat-icon fontSet="material-icons-outlined">content_copy</mat-icon>
            <span class="gost-action-button__text gost-action-button__text--compact" i18n="@@home.gostDigest.button.copyPrevious">前回の値をコピー</span>
          </button>
        </div>
        <div class="gost-input-toolbar__right">
          <div class="gost-global-actions gost-global-actions--plain">
            <button
              mat-flat-button
              type="button"
              class="mat-elevation-z0 gost-action-button gost-action-button--clear"
              [class.gost-action-button--icon-only]="isHandset"
              [matTooltip]="isHandset ? clearInputsTooltip : ''"
              i18n-aria-label="@@home.gostDigest.button.clearInputs"
              aria-label="入力をクリア"
              (click)="gost_digest_card.confirmClearInputContents()">
              <mat-icon fontSet="material-icons-outlined">delete_sweep</mat-icon>
              @if (!isHandset) {
                <span class="gost-action-button__text gost-action-button__text--compact" i18n="@@home.gostDigest.button.clearInputs">入力をクリア</span>
              }
            </button>
            <button
              mat-flat-button
              type="button"
              color="primary"
              class="mat-elevation-z0 gost-action-button gost-action-button--primary"
              [class.gost-action-button--icon-only]="isHandset"
              [matTooltip]="isHandset ? saveTooltip : ''"
              i18n-aria-label="@@home.gostDigest.button.save"
              aria-label="保存"
              [disabled]="!gost_digest_card.hasPendingChanges() || gost_digest_card.isSavingManual()"
              (click)="gost_digest_card.uploadGost2Data()">
              <mat-icon fontSet="material-icons-outlined">save</mat-icon>
              @if (!isHandset) {
                <span class="full-text" i18n="@@home.gostDigest.button.save">保存</span>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (!isInputMode()) {
    <div class="gost-infos__header">
      <app-details-header
        title="GOST｜食事能力目安"
        i18n-title="@@home.gostInfos.overview.title"
        badgeText="評価"
        i18n-badgeText="@@home.gostInfos.overview.badge"
        [patientName]="getHeaderPatientName()"
        [measureDate]="getHeaderMeasureDate()"
        [measurer]="getHeaderMeasurer()"
        [reportLink]="getGostReportLink()"
        [reportQueryParams]="getGostReportQueryParams()"
        reportLinkLabel="レポート"
        i18n-reportLinkLabel="@@home.gostInfos.overview.reportLink"
        reportTooltip="GOSTレポートへ"
        i18n-reportTooltip="@@home.gostInfos.overview.reportTooltip" />
    </div>
  }

  <div class="gost-input-layout" [class.gost-input-layout--manual]="isInputMode()">
    @if (!isInputMode()) {
      <mat-card class="gost-card gost-result-overview-card" appearance="outlined">
        <mat-card-content class="gost-result-overview">
          <div class="gost-result-overview__kpi-row">
            <article class="gost-result-overview__kpi-card gost-result-overview__kpi-card--fils">
              <div class="gost-result-overview__kpi-copy">
                <p class="gost-result-overview__kpi-label" i18n="@@home.gostInfos.kpi.filsLevel">推定FILSレベル</p>
                <p class="gost-result-overview__kpi-value">{{ getOverviewFilsLevelText() }}</p>
                <p class="gost-result-overview__kpi-sub">{{ getOverviewRecommendationText() }}</p>
              </div>
              <div class="gost-result-overview__kpi-icon-box">
                <mat-icon fontSet="material-icons-outlined">restaurant</mat-icon>
              </div>
            </article>

            <article class="gost-result-overview__kpi-card gost-result-overview__kpi-card--wst">
              <div class="gost-result-overview__kpi-copy">
                <p class="gost-result-overview__kpi-label" i18n="@@home.gostInfos.kpi.waterIntake">飲水量</p>
                <p class="gost-result-overview__kpi-value gost-result-overview__kpi-value--sm">{{ overviewWstAmountText }}</p>
                <p class="gost-result-overview__kpi-sub">{{ overviewWstStatusText }}</p>
              </div>
              <div class="gost-result-overview__kpi-icon-box">
                <mat-icon fontSet="material-icons-outlined">local_drink</mat-icon>
              </div>
            </article>

            <article class="gost-result-overview__kpi-card gost-result-overview__kpi-card--questionnaire">
              <div class="gost-result-overview__kpi-copy">
                <p class="gost-result-overview__kpi-label" i18n="@@home.gostInfos.kpi.questionnaire">質問票</p>
                <p class="gost-result-overview__kpi-value gost-result-overview__kpi-value--sm">
                  {{
                    overviewQuestionnaireTotalCount > 0
                      ? (overviewQuestionnairePositiveCount + " / " + overviewQuestionnaireTotalCount)
                      : "-"
                  }}
                </p>
                <p class="gost-result-overview__kpi-sub" i18n="@@home.gostInfos.kpi.cautionItems">注意項目</p>
              </div>
              <div class="gost-result-overview__kpi-icon-box">
                <mat-icon fontSet="material-symbols-outlined">fact_check</mat-icon>
              </div>
            </article>
          </div>

          <div class="gost-result-overview__detail-grid">
            <div class="gost-result-overview__wst-card">
              <div class="gost-result-overview__wst-header">
                <mat-icon fontSet="material-symbols-outlined">local_drink</mat-icon>
                <span i18n="@@home.gostInfos.wst.title">段階的水飲みテスト</span>
              </div>
              <div class="gost-result-overview__wst-table-header">
                <span i18n="@@home.gostInfos.wst.colWaterAmount">水量</span>
                <span i18n="@@home.gostInfos.wst.colFirst">1回目</span>
                <span i18n="@@home.gostInfos.wst.colSecond">2回目</span>
              </div>

              @if (!overviewWstAttemptRows.length) {
                <div class="gost-result-overview__wst-row">
                  <span>-</span>
                  <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                  <span class="gost-result-overview__wst-empty">—</span>
                </div>
              } @else {
                @for (row of overviewWstAttemptRows; track $index) {
                  <div class="gost-result-overview__wst-row">
                    <span>{{ row.amount != null ? (row.amount + " mL") : "-" }}</span>
                    <div class="gost-result-overview__wst-cell">
                      @if (!row.firstStatus.measured) {
                        <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                      } @else {
                        <div class="gost-result-overview__wst-main-badges">
                          @if (row.firstStatus.swallowPresent) {
                            <span class="gost-result-overview__badge is-good" i18n="@@home.gostInfos.badge.swallowPresent">嚥下あり</span>
                          }
                          @if (row.firstStatus.coughPresent) {
                            <span class="gost-result-overview__badge is-bad" i18n="@@home.gostInfos.badge.coughPresent">せき・むせ</span>
                          }
                          @if (hasOverviewWstCaution(row.firstStatus)) {
                            <span class="gost-result-overview__badge is-warn" i18n="@@home.gostInfos.badge.caution">注意</span>
                          }
                          @if (
                            !row.firstStatus.swallowPresent &&
                            !row.firstStatus.coughPresent &&
                            !hasOverviewWstCaution(row.firstStatus)
                          ) {
                            <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.noFindings">所見なし</span>
                          }
                        </div>
                      }
                    </div>
                    @if (row.secondStatus; as secondStatus) {
                      <div class="gost-result-overview__wst-cell">
                        @if (!secondStatus.measured) {
                          <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.notMeasured">未測定</span>
                        } @else {
                          <div class="gost-result-overview__wst-main-badges">
                            @if (secondStatus.swallowPresent) {
                              <span class="gost-result-overview__badge is-good" i18n="@@home.gostInfos.badge.swallowPresent">嚥下あり</span>
                            }
                            @if (secondStatus.coughPresent) {
                              <span class="gost-result-overview__badge is-bad" i18n="@@home.gostInfos.badge.coughPresent">せき・むせ</span>
                            }
                            @if (hasOverviewWstCaution(secondStatus)) {
                              <span class="gost-result-overview__badge is-warn" i18n="@@home.gostInfos.badge.caution">注意</span>
                            }
                            @if (
                              !secondStatus.swallowPresent &&
                              !secondStatus.coughPresent &&
                              !hasOverviewWstCaution(secondStatus)
                            ) {
                              <span class="gost-result-overview__badge is-default" i18n="@@home.gostInfos.badge.noFindings">所見なし</span>
                            }
                          </div>
                        }
                      </div>
                    } @else {
                      <span class="gost-result-overview__wst-empty">—</span>
                    }
                  </div>
                }
              }
            </div>

            <div class="gost-result-overview__risk-card">
              <div class="gost-result-overview__risk-header">
                <mat-icon fontSet="material-symbols-outlined">fact_check</mat-icon>
                <span i18n="@@home.gostInfos.risk.title">質問票の注意項目</span>
              </div>

              @if (!overviewRiskItems.length) {
                <div class="gost-result-overview__risk-empty" i18n="@@home.gostInfos.risk.noItems">該当なし</div>
              } @else {
                <div class="gost-result-overview__risk-pills">
                  @for (item of overviewRiskItems; track item.section + item.itemLabel) {
                    <span
                      class="gost-result-overview__risk-pill"
                      [ngClass]="getOverviewRiskClass(item)"
                      [matTooltip]="item.section + '｜' + item.itemLabel"
                      matTooltipClass="tooltip-wrap"
                      [attr.aria-label]="item.section + ' ' + item.itemLabel + ': ' + item.optionLabel">
                      {{ item.optionLabel }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <div class="gost-result-detail-divider" aria-hidden="true">
        <span i18n="@@home.gostInfos.label.resultDetail">結果詳細</span>
      </div>
    }

    @if (isHandset && !isInputMode()) {
      <div class="gost-mobile-section-buttons">
        <button
          type="button"
          class="gost-mobile-section-button"
          [class.gost-mobile-section-button--active]="mobileExpanded.sc"
          (click)="toggleMobileSection('sc')"
          aria-label="水飲みテストの詳細を表示"
          i18n-aria-label="@@home.gostInfos.mobile.scButtonAriaLabel">
          <mat-icon fontSet="material-icons-outlined" class="gost-mobile-section-button__icon">local_drink</mat-icon>
          <span class="gost-mobile-section-button__label" i18n="@@home.gostInfos.mobile.scButtonLabel">水飲みテスト</span>
        </button>
        <button
          type="button"
          class="gost-mobile-section-button"
          [class.gost-mobile-section-button--active]="mobileExpanded.gc"
          (click)="toggleMobileSection('gc')"
          aria-label="全身状態の詳細を表示"
          i18n-aria-label="@@home.gostInfos.mobile.gcButtonAriaLabel">
          <mat-icon fontSet="material-symbols-outlined" class="gost-mobile-section-button__icon">ecg_heart</mat-icon>
          <span class="gost-mobile-section-button__label" i18n="@@home.gostInfos.mobile.gcButtonLabel">全身状態</span>
        </button>
        <button
          type="button"
          class="gost-mobile-section-button"
          [class.gost-mobile-section-button--active]="mobileExpanded.oc"
          (click)="toggleMobileSection('oc')"
          aria-label="口腔機能の詳細を表示"
          i18n-aria-label="@@home.gostInfos.mobile.ocButtonAriaLabel">
          <mat-icon fontSet="material-symbols-outlined" class="gost-mobile-section-button__icon">assist_walker</mat-icon>
          <span class="gost-mobile-section-button__label" i18n="@@home.gostInfos.mobile.ocButtonLabel">口腔機能</span>
        </button>
      </div>
    }

    @if (isHandset) {
      <div class="gost-mobile-detail">
        @if (isInputMode() || mobileExpanded.sc) {
          <div #scSectionRef class="gost-section gost-section--sc" [class.gost-section--input]="isInputMode()">
            <ng-container [ngTemplateOutlet]="scSection"></ng-container>
          </div>
        }
        @if (isInputMode() || mobileExpanded.gc) {
          <div #gcSectionRef class="gost-section gost-section--gc" [class.gost-section--input]="isInputMode()">
            <ng-container [ngTemplateOutlet]="gcSection"></ng-container>
          </div>
        }
        @if (isInputMode() || mobileExpanded.oc) {
          <div #ocSectionRef class="gost-section gost-section--oc" [class.gost-section--input]="isInputMode()">
            <ng-container [ngTemplateOutlet]="ocSection"></ng-container>
          </div>
        }
      </div>
    } @else {
      <div class="gost-sections" [class.gost-sections--input]="isInputMode()">
        <div #scSectionRef class="gost-section gost-section--sc" [class.gost-section--input]="isInputMode()">
          <ng-container *ngTemplateOutlet="scSection"></ng-container>
        </div>
        <div #gcSectionRef class="gost-section gost-section--gc" [class.gost-section--input]="isInputMode()">
          <ng-container *ngTemplateOutlet="gcSection"></ng-container>
        </div>
        <div #ocSectionRef class="gost-section gost-section--oc" [class.gost-section--input]="isInputMode()">
          <ng-container *ngTemplateOutlet="ocSection"></ng-container>
        </div>
      </div>
    }
  </div>
} @else {
  <mat-card appearance="outlined">
    <mat-card-content i18n="@@home.gostInfos.label.noGostData">GOSTの詳細データが存在しません。</mat-card-content>
  </mat-card>
}
